module.exports = __webpack_public_path__ + "static/media/Alaa aldabak.ac42c4e7.png";